export { Ingredients } from './ingredients.component';
